import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-with-nav-bar',
  templateUrl: './with-nav-bar.component.html'
})
export class WithNavBarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
